import React, { useState, useRef, useEffect } from 'react';
import { DivFormGroup, DivInput, FixedSelect, FixedSelectSpan, LabelInput } from './styles';

function SelectFixo({ options, styleAux, selectedOptionValue, onChange, isLabel, label, value, multiple, disabled }) {
  const [selectedOption, setSelectedOption] = useState(selectedOptionValue);
  const selectRef = useRef(null);

  const handleSelectOption = (selectedOption) => {
    if (!selectedOption){ 
      const newSelectedOption = {value: '', text: ''} 
      setSelectedOption(newSelectedOption);
      onChange(newSelectedOption);
    }else{
      setSelectedOption(selectedOption);
      onChange(selectedOption);
    }
  };

  useEffect(() => {
    function handleMenuPosition() {
      if (selectRef.current && selectRef.current.select && selectRef.current.select.control) {
        const selectRect = selectRef.current.select.control.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (selectRect.bottom + 200 > windowHeight) {
          selectRef.current.select.setState({ menuPlacement: 'top' });
        } else {
          selectRef.current.select.setState({ menuPlacement: 'bottom' });
        }
      }
    }

    handleMenuPosition();

    window.addEventListener('resize', handleMenuPosition);

    return () => {
      window.removeEventListener('resize', handleMenuPosition);
    };
  }, []);

  return (
    <>
      {isLabel !== undefined && label && (
        <DivFormGroup >
          <LabelInput id="inputGroup-sizing-sm" className="input-group-text">{label}</LabelInput>
          <DivInput>
            <FixedSelect
              ref={selectRef}
              options={options}
              isMulti={multiple}
              isSearchable
              isDisabled={disabled}
              isClearable={true} // Permite limpar
              onChange={(selectOption) => { handleSelectOption(selectOption); }}
              getOptionValue={(option) => option.value}
              getOptionLabel={(option) => option.text}
              value={selectedOptionValue}
              style={styleAux}
              placeholder="Selecione..."
              menuPortalTarget={document.body}
            />
          </DivInput>
        </DivFormGroup>
      )}

      {isLabel !== undefined && !label && (
        <FixedSelect
          ref={selectRef}
          options={options}
          isMulti={multiple}
          isSearchable
          isDisabled={disabled}
          onChange={(selectOption) => { handleSelectOption(selectOption); }}
          getOptionValue={(option) => option.value}
          getOptionLabel={(option) => option.text}
          value={selectedOptionValue}
          style={styleAux}
          placeholder="Selecione..."
          menuPortalTarget={document.body}
        />
      )}

      {!isLabel && (
        <FixedSelectSpan
          ref={selectRef}
          options={options}
          isMulti={multiple}
          isSearchable
          isDisabled={disabled}          
          onChange={(selectOption) => { handleSelectOption(selectOption); }}
          getOptionValue={(option) => option.value}
          getOptionLabel={(option) => option.text}
          value={selectedOption}
          style={styleAux}
          menuPortalTarget={document.body}
        />
      )}
    </>
  );
};

export default SelectFixo;
